import { render, staticRenderFns } from "./footbar.vue?vue&type=template&id=1b1f8ac6&"
import script from "./footbar.vue?vue&type=script&lang=js&"
export * from "./footbar.vue?vue&type=script&lang=js&"
import style0 from "./footbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports